<template>
	<div style="margin-left: 20px">
		<el-button
			:loading="downloadLoading"
			type="primary"
			size="medium"
			icon="el-icon-document"
			@click="handleDownload"
		>
			导出身份信息表
		</el-button>
	</div>
</template>

<script>
export default {
	components: {},
	props: {
		params: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			downloadLoading: false,
			list: [],
			columns: [
				{
					title: "序号",
					value: "id",
				},
				{
					title: "是否已取得登记证照",
					value: "is_djzz",
				},
				{
					title: "名称（已取得登记证照）",
					value: "qddjzz.xm",
				},
				{
					title: "统一社会信用代码（纳税人识别号）（已取得登记证照）",
					value: "qddjzz.dp_idtyshxydm",
				},
				{
					title: "专业服务机构标识（已取得登记证照）",
					value: "qddjzz.zyfwjgbs",
				},
				{
					title: "姓名（未取得登记证照）",
					value: "wqddjzz.name",
				},
				{
					title: "证件类型（未取得登记证照）",
					value: "wqddjzz.zjlx",
				},
				{
					title: "证件号码（未取得登记证照）",
					value: "wqddjzz.zjhm",
				},
				{
					title: "国家或地区（未取得登记证照）",
					value: "wqddjzz.gj",
				},
				{
					title: "是否存在免于报送收入信息情形（未取得登记证照）",
					value: "wqddjzz.is_mybsxx",
				},
				{
					title: "免报类型（未取得登记证照）",
					value: "wqddjzz.mblx",
				},
				{
					title: "地址",
					value: "address",
				},
				{
					title: "店铺（用户）名称",
					value: "dp_name",
				},
				{
					title: "店铺（用户）唯一标识码",
					value: "dp_id",
				},
				{
					title: "网址链接（选填）",
					value: "url",
				},
				{
					title: "开户银行/非银行支付机构（结算（支付）账户信息（选填））",
					value: "jszhxx.khyh",
				},
				{
					title: "账户名称（结算（支付）账户信息（选填））",
					value: "jszhxx.zhmc",
				},
				{
					title: "银行账户/支付账号（结算（支付）账户信息（选填））",
					value: "jszhxx.yhzh",
				},
				{
					title: "联系人姓名",
					value: "lxrxm",
				},
				{
					title: "联系电话",
					value: "lxrdh",
				},
				{
					title: "经营开始时间",
					value: "jy_time",
				},
				{
					title: "经营结束时间",
					value: "jyjssj",
				},
				{
					title: "信息状态标识",
					value: "xxztbs",
				},
			],
		};
	},

	computed: {},

	methods: {
		//导出
		async handleDownload() {
			try {
				let falg = await this.init("export");
				if (!falg) {
					return;
				}
				console.log(this.list, "list");
				import("@/excel/Export2Excel").then((excel) => {
					let sHeader = this.columns.map((item) => item.title);
					const data = this.formatJson(this.list);
					const time = new Date().getTime() + Math.random() * 1000;
					let filename = `导出身份信息表${time}`;
					excel.export_json_to_excel({
						header: sHeader, //Header Required
						data, //Specific data Required
						filename: filename, //Optional
						autoWidth: true, //Optional
						bookType: "xlsx", //Optional
					});
					this.downloadLoading = false;
				});
			} catch (error) {
				this.downloadLoading = false;
			}
		},
		//转换导出数据
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let tempArr = [];
				this.columns.map((item) => {
					if (item.value.indexOf(".") != "-1") {
						tempArr.push(eval(`v.${item.value}`));
					} else {
						tempArr.push(v[item.value]);
					}
				});
				return tempArr;
			});
		},
		checkParams() {
			if (!this.params.month) {
				this.$message.error("请选择时间");
				return false;
			}
			if (!this.params.channel_account) {
				this.$message.error("请选择税源地");
				return false;
			}
			return true;
		},
		// 初始化列表
		async init() {
			console.log(this.params, "params");
			if (!this.checkParams()) {
				return;
			}
			let params = {
				...this.params,
				current_page: 1,
				page_size: 99999999,
			};
			this.downloadLoading = true;
			let { data } = await this.$api.get_qxy_tax_export_declare_employee(
				params
			);

			this.list = data;
			return true;
		},
	},
	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
	margin-bottom: 0;
}
.tip {
	display: flex;
	font-size: 16px;
	margin-bottom: 24px;
	.dan-tip {
		margin-left: 24px;
		color: #d9001b;
	}
}
.name {
	cursor: pointer;
	color: #409eff;
}
.flex-bw {
	display: flex;
	justify-content: space-between;
}
.btn-box {
	width: 360px;
	flex: none;
}
.table-right {
	float: right;
}
</style>
